import { Injectable, OnDestroy } from '@angular/core';
import confetti from 'canvas-confetti';

@Injectable()
export class ConfettiService implements OnDestroy {
  constructor() {}
  ngOnDestroy(): void {
    confetti.reset();
  }

  celebrate() {
    const duration = 3000;

    confetti({
      particleCount: 150,
      spread: 180,
      origin: { y: 0.6 },
      colors: ['#FF4500', '#008080', '#FFD700'],
    });

    setTimeout(() => confetti.reset(), duration);
  }

  fireWorks() {
    let duration = 2 * 1000;
    let animationEnd = Date.now() + duration;
    let defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

    let interval = setInterval(() => {
      var timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      var particleCount = 50 * (timeLeft / duration);
      // since particles fall down, start a bit higher than random
      confetti({
        ...defaults,
        particleCount,
        origin: { x: this.randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      });
      confetti({
        ...defaults,
        particleCount,
        origin: { x: this.randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      });
    }, 250);
  }

  firePrideWorks() {
    let end = Date.now() + 3 * 1000;

    // go Buckeyes!
    // let colors = ['#FFFF00', '#FF4500'];

    (function frame() {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        // colors: colors,
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        // colors: colors,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }

  fireRealWorks() {
    let count = 200;
    let defaults = {
      origin: { y: 0.7 },
    };

    function realWorks(particleRatio: any, opts: any) {
      confetti({
        ...defaults,
        ...opts,
        particleCount: Math.floor(count * particleRatio),
      });
    }

    realWorks(0.25, {
      spread: 26,
      startVelocity: 55,
    });
    realWorks(0.2, {
      spread: 60,
    });
    realWorks(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
    });
    realWorks(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
    });
    realWorks(0.1, {
      spread: 120,
      startVelocity: 45,
    });
  }

  randomInRange(min: any, max: any) {
    return Math.random() * (max - min) + min;
  }
}
